import { useTranslation } from "react-i18next";
import React from "react";
import { useHistory } from "react-router-dom";

import "./styles.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";
import {CSM_HOME_PATH, HOME_PATH} from "../../utils/constants";

//reference: https://codepen.io/ricardpriet/pen/qVZxNo

export default function Page404() {
    const { t } = useTranslation();
  let history = useHistory();
  let {isCSMSystem} = useCSMAccessCheck();

  return (
    <div className="no-match-page-container">
      <h1 className="centered-title">{t("common.pageNotFound")}</h1>
      <section className="error-container">
        <span className="four">
          <span className="screen-reader-text">4</span>
        </span>
        <span className="zero">
          <span className="screen-reader-text">0</span>
        </span>
        <span className="four">
          <span className="screen-reader-text">4</span>
        </span>
          <div className="link-container">
              <YuJaButton onClick={() => {history.goBack()}}>{t("common.goBack")}</YuJaButton>
              <div style={{flex: 1}}/>
              <YuJaButton onClick={() => {history.push(isCSMSystem() ? CSM_HOME_PATH : HOME_PATH)}}>{t("common.goToHomePage")}</YuJaButton>
          </div>
      </section>

    </div>
  );
}
